export default __webpack_public_path__ + "static/f9985eeea679e63aa34ea65af4fd7f86.jpg";